import { Trans } from '@/components'
import { Instance } from '@/models/instance'

import { InstanceAccess } from './InstanceAccess'
import { InstancePublicIP } from './InstancePublicIP'

export function InstanceAccessWithPublicIP({
  instance,
  onUpdate,
  readOnly = false,
}: {
  instance: Instance
  onUpdate?: () => void
  readOnly?: boolean
}) {
  return (
    <div className="bg-panel-gray-100 rounded-lg">
      <div className="p-4">
        <div className="text-tertiary t-xs mb-2">
          <Trans i18nKey="instance.access.publicIPInfo">Public IP Information</Trans>
        </div>
        <InstancePublicIP instance={instance} />
      </div>

      <InstanceAccess
        instance={instance}
        onUpdate={onUpdate}
        bgClassName="bg-transparent"
        readOnly={readOnly}
      />
    </div>
  )
}
